/**
 * Per-environment URLs the landing links out to.
 *
 * Read from Vite env vars at build time so staging / prod / regional
 * builds can swap them without code changes (DIT-194 review-2 #3
 * and LOW #14). `.env.example` documents the canonical values.
 */

const stripTrailingSlash = (s: string) => s.replace(/\/+$/, '');

export const DASHBOARD_URL = stripTrailingSlash(
  import.meta.env.VITE_DASHBOARD_URL || 'https://dashboard.stage.done-it.app',
);

export const MARKETING_URL = stripTrailingSlash(
  import.meta.env.VITE_MARKETING_URL || 'https://done-it.app',
);

export const DASHBOARD_LOGIN_URL = `${DASHBOARD_URL}/login`;
// TODO(DIT-229): point to a real /terms page once the marketing
// site has one; for now we route visitors back to the marketing
// home so the link is at least not a 404.
export const TERMS_URL = MARKETING_URL;
// TODO(DIT-229): same as above for /privacy.
export const PRIVACY_URL = MARKETING_URL;
// TODO(DIT-229): same as above for /tour — the explainer video /
// tour landing isn't published yet.
export const TOUR_URL = MARKETING_URL;
export const CONTACT_EMAIL = 'hello@done-it.app';

// App store links — corrected to the actually published Done-it
// listings (DIT-229 #5). Earlier values pointed at a placeholder
// Apple ID and a wrong Android bundle; both 404'd.
export const APP_STORE_URL =
  'https://apps.apple.com/nl/app/done-it/id6444494390';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=be.done_it.app';
